import React from "react";
import { motion } from "framer-motion";
import { FaCoins, FaShieldAlt, FaGlobe, FaChartLine } from "react-icons/fa";

const Staking = () => {
  return (
    <section id="staking" className="py-16 px-6 bg-cover bg-center relative">
      <div className="absolute inset-0 bg-black bg-opacity-90"></div>

      <div className="relative max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-4xl font-bold text-yellow-400 mb-8 inline-block border-b-4 border-red-600 px-4 pb-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Staking with Smartnodes
        </motion.h2>

        <p className="text-gray-300 text-lg mb-10">
          Secure the network, earn rewards, and contribute to blockchain stability by running a Smartnode.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-yellow-400 flex items-start space-x-4"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaCoins className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-red-400">Why Stake MENEL?</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>
                  Smartnodes require a collateral of{" "}
                  <strong className="text-yellow-400">600,000 MENEL</strong>.
                </li>
                <li>
                  Earn{" "}
                  <strong className="text-yellow-400">15% per block (750 MENEL)</strong>.
                </li>
                <li>
                  High returns with an APY of{" "}
                  <strong className="text-red-400">over 100%</strong>.
                </li>
                <li>
                  Flexible staking from{" "}
                  <strong className="text-gray-300">600,000 to 1,800,000 MENEL</strong>.
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-red-600 flex items-start space-x-4"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaShieldAlt className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-yellow-400">Enhanced Security</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>
                  Strengthen blockchain security with{" "}
                  <strong className="text-yellow-400">ChainLock</strong>.
                </li>
                <li>Mitigate risks of 51% attacks.</li>
                <li>Help validate transactions and maintain decentralization.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-yellow-400 flex items-start space-x-4"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaGlobe className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-red-400">Governance & Community</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Participate in governance and decision-making.</li>
                <li>Vote on network upgrades and proposals.</li>
                <li>Help shape the future of Menelik.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-red-600 flex items-start space-x-4"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaChartLine className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-yellow-400">Passive Income</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Earn rewards by running a Smartnode.</li>
                <li>Generate stable and predictable income.</li>
                <li>Maximize gains with optimized staking strategies.</li>
              </ul>
            </div>
          </motion.div>
        </div>

        <p className="text-center text-gray-300 mt-10 text-lg font-semibold">
          Secure the network and earn rewards with Menelik Staking.
        </p>
      </div>
    </section>
  );
};

export default Staking;
